import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormControlLabel from "@mui/material/FormControlLabel";

const GetIcon = ({
  title = "",
  icon,
  iconStyles = {},
  iconClass = "",
  labelPlacement = "end",
  spin,
  sx = {},
  ...rest
}) => {

  return (
    <FormControlLabel
      sx={{
        m: 0,
        minHeight: 0,
        cursor: "inherit",
        "& .MuiFormControlLabel-label": {
          fontSize: "inherit",
          lineHeight: 1.25,
          color: "inherit",
        },
        ...sx,
      }}
      {...rest}
      control={
        icon ? (
          <GetFontAwesomeIcon
            icon={icon}
            spin={spin}
            iconStyles={iconStyles}
            iconClass={iconClass}
          />
        ) : (
          <></>
        )
      }
      label={title}
      labelPlacement={labelPlacement}
    />
  );
};

export default GetIcon;

export const GetFontAwesomeIcon = ({
  icon,
  spin,
  iconClass = "",
  iconStyles = {},
  ...rest
}) => {
  return (
    <FontAwesomeIcon
      icon={icon}
      spin={spin}
      style={{
        marginRight: "3px",
        fontSize: "0.8rem",
        fontWeight: "400",
        color: "inherit",
        ...iconStyles,
      }}
      className={iconClass}
      {...rest}
    />
  );
};
